<template>
    <v-dialog
        :model-value="isOpen"
        min-height="170px"
        max-width="600px"
        transition="slide-y-transition"
        eager
        :persistent="actionLoading"
        @keydown.enter="onConfirm"
        @keydown.esc="onAbort"
        @click:outside="onAbort"
        @after-leave="onAfterLeave"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    <slot name="title" />
                </h1>
            </v-card-title>

            <v-card-text class="text-center">
                <slot name="content" />
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    :color="removal ? 'info' : 'error'"
                    variant="text"
                    :disabled="actionLoading"
                    data-sentry-label="Anulowanie"
                    @click="onAbort"
                >
                    <slot name="abortButton">{{ abortButtonText || t('common.buttons.cancel') }}</slot>
                </v-btn>

                <v-spacer />

                <v-btn
                    :color="removal ? 'error' : 'success'"
                    variant="text"
                    :loading="actionLoading"
                    data-sentry-label="Potwierdzenie"
                    @click="onConfirm"
                >
                    <slot name="confirmButton">{{ confirmButtonText || t('common.buttons.yes') }}</slot>
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script setup>
/*
  Organization / ordering applied:
  1. Imports
  2. Props / Emits
  3. Constants
  4. Stores & top-level services
  5. Reactive state (refs/reactive)
  6. Validation rules & setup
  7. Computed
  8. Handlers / methods
  9. Helpers / lifecycle
*/

// 1. Imports
import { toRefs } from 'vue'
import { useI18n } from 'vue-i18n'

// 2. Props / Emits
const props = defineProps({
    isOpen: Boolean,
    data: {
        type: Object,
        default: () => ({})
    },
    removal: Boolean,
    actionLoading: Boolean,
    abortButtonText: {
        type: String,
        default: ''
    },
    confirmButtonText: {
        type: String,
        default: ''
    }
})

const emit = defineEmits(['on-confirm', 'on-abort', 'after-leave'])

// 3. Constants

// 4. Stores & top-level services

// 5. Reactive state (refs/reactive)
const { isOpen, data, removal, actionLoading, abortButtonText, confirmButtonText } = toRefs(props)
const { t } = useI18n()

// 6. Validation rules & setup

// 7. Computed

// 8. Handlers / methods
function onConfirm() {
    if (isActionBlocked()) return
    const payload = clonePayload(data?.value)

    emit('on-confirm', payload)
}

function onAbort() {
    if (isActionBlocked()) return

    emit('on-abort')
}

function onAfterLeave() {
    emit('after-leave')
}

// 9. Helpers / lifecycle
const clonePayload = (val) => {
    if (val && typeof val === 'object') {
        return JSON.parse(JSON.stringify(val))
    }

    return val ?? null
}

const isActionBlocked = () => Boolean(actionLoading?.value)
</script>
